<app-basket-simple-view [title]="title" (orderLinesRemovedByDate)="onOrderLinesRemovedByDate($event)"
  [header]="'Booking-basket-header' | translate:{ prefix: prefix | translate, weekShort: weekShort, day: day, monthShort: monthShort, time: time, pickUpPointName: pickUpPointName}"
  [allowDeleteLastDate]="allowDeleteLastDate">
</app-basket-simple-view>
